import PaymentLink from 'components/payments/paymentLink';
import Skeleton from 'components/layouts/Skeleton';

export default function PaymentLinkPage(props) {
  return (
    <PaymentLink {...props} />
  );
}

PaymentLinkPage.getLayout = (page) => <Skeleton page={page} />;

export const getServerSideProps = async (ctx) => {
  const { getPaymentLinkProps } = require('containers/api/paymentLink');
  return getPaymentLinkProps(ctx);
};
